<template lang="html">
<div>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="12">
            <span class="card-title wise-card-title">쿠폰관리 </span>
          </b-col>
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>쿠폰명</strong></b-col>
          <b-col sm="2">
            <b-form-input v-model="queryParams.coupon_name" placeholder="" ></b-form-input>
          </b-col>
          <b-col sm="1">
            <b-button variant="primary" v-on:click="selectCouponList()">검색</b-button>
          </b-col>
        </b-row>
        <b-row class="pt-sm-3">
          <b-col sm="1"></b-col>
          <b-col sm="1" ><strong>발행일</strong></b-col>
          <b-col sm="2"><b-form-input type="text" name="daterange" /></b-col>
          <b-col sm="8">
            <b-button variant="outline-primary" style="float:left;margin-right:5px" v-on:click="changeCalendar('all')">전체</b-button>
            <b-button variant="outline-primary" style="float:left;margin-right:5px" v-on:click="changeCalendar('today')">오늘</b-button>
            <b-button variant="outline-primary" style="float:left;margin-right:5px" v-on:click="changeCalendar('1w')">1주일</b-button>
            <b-button variant="outline-primary" style="float:left;margin-right:5px" v-on:click="changeCalendar('1m')">1달</b-button>
            <b-button variant="outline-primary" style="float:left;margin-right:5px" v-on:click="changeCalendar('6m')">6달</b-button>
            <b-button variant="outline-primary" style="float:left;margin-right:5px" v-on:click="changeCalendar('1y')">1년</b-button>
          </b-col>
        </b-row>
        <b-row class="pt-sm-4">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>쿠폰구분</strong></b-col>
          <b-col sm="3">
            <b-form-group>
              <b-form-radio-group v-model="queryParams.coupon_type">
                <b-form-radio value="">전체</b-form-radio>
                <b-form-radio value="CT_1">할인쿠폰</b-form-radio>
                <!-- <b-form-radio value="CT_2">기간제 이용권</b-form-radio> -->
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="1"><strong>쿠폰상태</strong></b-col>
          <b-col sm="4">
            <b-form-group>
              <b-form-radio-group v-model="queryParams.coupon_status">
                <b-form-radio value="">전체</b-form-radio>
                <b-form-radio value="1">지급중</b-form-radio>
                <b-form-radio value="2">기간만료</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////// -->
        <hr>
        <b-row class="mt-sm-2">
          <b-col sm="12">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="2">
                <span class="pr-1"><strong>총 {{totalRows}}건</strong></span>
              </b-col>
              <b-col sm="6"></b-col>
              <b-col md="2" class="my-1">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="10">
                <b-table
                  hover
                  outlined
                  :fields="fields"
                  :items="items"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="couponRowSelected"
                >
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="10" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-button variant="outline-primary" style="float:right;" v-on:click="formModal=true">신규등록</b-button>
          </b-col>
          <b-col sm="1"></b-col>
        </b-row>
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////// -->
        <hr>
        <div v-show="!showPubManagement">
          <b-row class="pt-3">
            <b-col sm="1"></b-col>
            <b-col sm="11">
              <div style="font-size:18px;font-weight:600;color:#cccccc">
                <p>관리할 쿠폰을 선택 하세요.</p>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-show="showPubManagement">
        <b-row class="pt-sm-1">
          <b-col sm="12">
            <span class="card-title wise-card-title">발행관리 </span>
          </b-col>
        </b-row>
        <b-row class="pt-sm-1">
          <b-col sm="1"></b-col>
          <b-col sm="10">
            <table class="table table-bordered oddBackground">
              <tbody>
                <tr>
                  <td>쿠폰구분</td>
                  <td>{{selectedCoupon.coupon_type}}</td>
                  <td>쿠폰코드</td>
                  <td>{{selectedCoupon.coupon_code}}</td>
                </tr>
                <tr>
                  <td>쿠폰명</td>
                  <td>{{selectedCoupon.coupon_name}}</td>
                  <td>쿠폰설명</td>
                  <td>{{selectedCoupon.coupon_desc}}</td>
                </tr>
                <tr>
                  <td>발행수량</td>
                  <td>{{selectedCoupon.coupon_cnt}}</td>
                  <td>사용수량</td>
                  <td>{{selectedCoupon.counpon_useCnt}}</td>
                </tr>
                <tr>
                  <td>발행일</td>
                  <td>{{selectedCoupon.start_date}}</td>
                  <td>만료일</td>
                  <td>{{selectedCoupon.end_date}}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="pt-sm-5">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>아이디/이름</strong></b-col>
          <b-col sm="3">
            <b-form-input v-model="pub_queryParams.user_name" placeholder="" ></b-form-input>
          </b-col>
          <b-col sm="1">
            <b-button variant="primary" v-on:click="selectCouponPubList()">검색</b-button>
          </b-col>
        </b-row>
        <b-row class="pt-sm-3">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>쿠폰일련번호</strong></b-col>
          <b-col sm="3">
            <b-form-input v-model="pub_queryParams.coupon_pub_id" placeholder="" ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="pt-sm-3">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>쿠폰상태</strong></b-col>
          <b-col sm="4">
            <b-form-group>
              <b-form-radio-group v-model="pub_queryParams.coupon_pub_status">
                <b-form-radio value="">전체</b-form-radio>
                <b-form-radio value="1">지급가능</b-form-radio>
                <b-form-radio value="2">지급완료</b-form-radio>
                <b-form-radio value="3">사용완료</b-form-radio>
                <b-form-radio value="4">만료</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-sm-2">
          <b-col sm="12">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="2">
                <span class="pr-"><strong>총 {{pub_totalRows}}건</strong></span>
              </b-col>
              <b-col sm="6"></b-col>
              <b-col md="2" class="my-1">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select v-model="pub_perPage" :options="pub_pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="10">
                <b-table
                  outlined
                  :fields="pub_fields"
                  :items="pub_items"
                  :current-page="pub_currentPage"
                  :per-page="pub_perPage"
                >
                  <template slot="관리" slot-scope="row">
                    <b-button variant="primary" v-if="row.item.coupon_pub_status == 1" v-on:click="selectPubCoupon(row.item)">지급</b-button>
                    <b-button variant="danger" v-if="row.item.coupon_pub_status != 1" v-on:click="expirePubCoupon(row.item)">만료</b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="10" class="my-1">
                <b-pagination
                  v-model="pub_currentPage"
                  :total-rows="pub_totalRows"
                  :per-page="pub_perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        </div>
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////// -->
      </b-card>
    </b-col>
  </b-row>
  <b-modal title="쿠폰관리" size="lg" v-model="formModal" @ok="formModal = false"
  no-close-on-backdrop no-close-on-esc hide-footer>
    <CouponDetailFormModal v-bind:couponDetail="couponDetail" v-bind:newFlag="newFlag"></CouponDetailFormModal>
    <hr />
    <span class="float-right" style="padding-right:20px;">
      <b-button variant="outline-primary" @click="couponSave()">저장</b-button>
      <b-button variant="outline-success" @click="formModal = false">취소</b-button>
    </span>
  </b-modal>
  <b-modal title="회원검색" size="lg" v-model="searchModal" @ok="searchModal = false">
    <b-row>
      <b-col sm="1"></b-col>
      <b-col sm="2">
        <span class="float-right"><strong>회원검색</strong></span>
      </b-col>
      <b-col sm="3">
        <b-form-input v-model="user_queryParams.name" placeholder="" ></b-form-input>
      </b-col>
      <b-col sm="2">
        <b-button variant="primary" v-on:click="findUser()">검색</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" v-show="listLoading">
        <b-row>
          <b-col sm="5"></b-col>
          <b-col sm="5" class="pt-5 pb-5">
            <PulseLoader color='#20a8d8'></PulseLoader>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" class="pt-5" v-show="!listLoading">
        <b-table
          hover
          outlined
          :fields="user_fields"
          :items="user_items"
          :current-page="user_currentPage"
          :per-page="user_perPage"
          @row-clicked="user_rowSelected"
        >
        </b-table>
      </b-col>
      <b-col sm="12" class="pt-sm-1">
        <b-row class="pb-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="10" class="my-1">
            <b-pagination
              v-model="user_currentPage"
              :total-rows="user_totalRows"
              :per-page="user_perPage"
              align="center"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</div>
</template>

<script>
import swal from 'sweetalert2';
import datetimepicker from "daterangepicker/daterangepicker.js";
import CouponDetailFormModal from "./CouponDetailFormModal";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

const moment = require("moment");

export default {
  components: {
    CouponDetailFormModal,
    PulseLoader
  },
  data() {
    return {
      showPubManagement:false, // 발행관리 화면 show/hide
      // ----
      selectedPubCoupon:'', // 선택된 발행쿠폰
      listLoading : false,
      searchModal : false,
      // ----
      user_totalRows: 0, // 회원검색MODAL관련
      user_currentPage: 1, // 회원검색MODAL관련
      user_perPage: 5, // 회원검색MODAL관련
      user_pageOptions: [5, 10, 30, 50, 100], // 회원검색MODAL관련
      user_queryParams: { // 회원검색MODAL관련
        name: '',
        ageRange: [],
        letter_yn: [],
        gender: [],
        grade: [],
        industry_key: [],
        authority: [],
        user_status: [],
        endDate: '',
        startDate: '',
        employee : [],
      },
      user_fields: [ // 회원검색MODAL관련
      {
        'user_id': {
          'label': '아이디',
        }
      }, {
        'name': {
          'label': '이름',
        }
      }, {
        'grade_name': {
          'label': '등급',
        }
      }, {
        'authority_name': {
          'label': '계정회원',
        }
      }, {
        'gender_name': {
          'label': '성별',
        }
      }],
      user_items:[], // 회원검색MODAL관련
      userDetailInfo:{}, // 회원검색MODAL관련
      // ----
      selectedCoupon:{
      },
      couponDetail:{
        coupon_code: '',
        coupon_type: 'CT_1',
        coupon_name: '',
        coupon_desc: '',
        coupon_cnt: 200,
        start_date: '',
        end_date: ''
      },
      newFlag:'new', // 쿠폰 신규등록 폼(FORM) SHOW/HIDE
      formModal: false,
      // ---- 쿠폰 검색 조건
      queryParams: {
        coupon_name: '',
        end_date: moment().format('YYYY-MM-DD'),
        start_date: moment().add(-10, 'years').format('YYYY-MM-DD'),
        coupon_type: '',
        coupon_status: '',
      },
      calendarLocale: {
        "format": "YY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1", "2", "3", "4", "5", "6",
          "7", "8", "9", "10", "11", "12"
        ],
        "firstDay": 1
      },
      // ----
      totalRows: 0, // 쿠폰 리스트 테이블 관련
      currentPage: 1, // 쿠폰 리스트 테이블 관련
      perPage: 5, // 쿠폰 리스트 테이블 관련
      pageOptions: [5, 10, 30, 50, 100], // 쿠폰 리스트 테이블 관련
      fields: [ // 쿠폰 리스트 테이블 관련
        {
          'rnum': {
            'label': '번호',
          }
        }, {
          'coupon_code': {
            'label': '쿠폰코드',
          }
        }, {
          'coupon_type': {
            'label': '구분',
          }
        }, {
          'coupon_name': {
            'label': '쿠폰명',
          }
        }, {
          'start_date': {
            'label': '발행일',
          }
        }, {
          'end_date': {
            'label': '만료일',
          }
        }, {
          'coupon_cnt': {
            'label': '발행수량',
          }
        }, {
          'used_cnt': {
            'label': '사용수량',
          }
        }, {
          'coupon_status_name': {
            'label': '상태',
          }
        }, '관리'
      ],
      items: [], // 쿠폰 리스트 테이블 관련
      // ----
      pub_totalRows: 0, // 발행 쿠폰 리스트 테이블 관련
      pub_currentPage: 1, // 발행 쿠폰 리스트 테이블 관련
      pub_perPage: 5, // 발행 쿠폰 리스트 테이블 관련
      pub_pageOptions: [5, 10, 30, 50, 100], // 발행 쿠폰 리스트 테이블 관련
      pub_queryParams: { // 발행 쿠폰 리스트 테이블 관련
        user_name:'',
        coupon_pub_id:'',
        coupon_pub_status:''
      },
      pub_fields: [ // 발행 쿠폰 리스트 테이블 관련
        {
          'rnum': {
            'label': '번호',
          }
        }, {
          'coupon_pub_id': {
            'label': '일련번호',
          }
        }, {
          'user_id': {
            'label': '아이디',
          }
        }, {
          'user_name': {
            'label': '이름',
          }
        }, {
          'pub_date': {
            'label': '지급일',
          }
        }, {
          'pub_use_date': {
            'label': '사용일',
          }
        }, {
          'coupon_pub_status_name': {
            'label': '상태',
          }
        }, '관리'
      ],
      pub_items: [], // 발행 쿠폰 리스트 테이블 관련
      // ----
    }
  },
  watch: {},
  mounted: function() {
    this.drawCalendar(moment().add(-10, 'years').format('YY-MM-DD'), moment().format('YY-MM-DD'));
    this.selectCouponList();
  },
  methods: {
    // 메소드명 : changeCalendar(range)
    // ### 캘린더 날짜 자동 입력 ###
    // 버튼에 선택된 기간조건으로 캘린더에 날짜 자동 입력
    // '전체', '오늘', '1주일', '1달', '6달', '1년'
    // 최초작성 : 2019.07.01
    // 파라미터 :
    //  - range : 기간
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    changeCalendar(range){
      switch (range) {
        case 'all':
          this.drawCalendar(moment().add(-10, 'years').format('YY-MM-DD'), moment().format('YY-MM-DD'));
          break;
        case 'today':
          this.drawCalendar(moment().format('YY-MM-DD'), moment().format('YY-MM-DD'));
          break;
        case '1w':
          this.drawCalendar(moment().add(-1, 'weeks').format('YY-MM-DD'), moment().format('YY-MM-DD'));
          break;
        case '1m':
          this.drawCalendar(moment().add(-1, 'months').format('YY-MM-DD'), moment().format('YY-MM-DD'));
          break;
        case '6m':
          this.drawCalendar(moment().add(-6, 'months').format('YY-MM-DD'), moment().format('YY-MM-DD'));
          break;
        case '1y':
          this.drawCalendar(moment().add(-1, 'years').format('YY-MM-DD'), moment().format('YY-MM-DD'));
          break;
        default:
      }
    },
    // 메소드명 : drawCalendar(start_date, end_date)
    // ### 캘린더 그리기 ###
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    //  - start_date : 시작일
    //  - end_date : 종료일
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    drawCalendar(start_date, end_date){
      var self = this;
      $(function() {
        $('input[name="daterange"]').daterangepicker({
          opens: 'left',
          showDropdowns: true,
          "locale": self.calendarLocale,
          "startDate": start_date,
          "endDate": end_date
        }, function(start, end, label) {
          self.queryParams.start_date = start.format('YYYY-MM-DD');
          self.queryParams.end_date = end.format('YYYY-MM-DD');
        });
      });
    },
    // 메소드명 : selectCouponList()
    // ### 쿠폰리스트조회 ###
    // 검색조건(queryParams)에 맞는 쿠폰 리스트 조회
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    selectCouponList(){
      this.showPubManagement = false;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append('objs', param);
      this.$http.post('/api/select/couponList?access_token='+token, data, null)
      .then((result) => {
        this.items = result.data;
        this.totalRows = this.items.length;
      })
    },
    // 메소드명 : selectCouponPubList()
    // ### 쿠폰 발행리스트조회 ###
    // 선택된 쿠폰(selectedCoupon)에 맞는 쿠폰 발행 리스트 조회
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    selectCouponPubList(){
      var token = sessionStorage.getItem("myToken");
      this.selectedCoupon.user_name         = this.pub_queryParams.user_name;
      this.selectedCoupon.coupon_pub_id     = this.pub_queryParams.coupon_pub_id;
      this.selectedCoupon.coupon_pub_status = this.pub_queryParams.coupon_pub_status;

      var param = encodeURI(JSON.stringify(this.selectedCoupon));
      var data = new FormData();
      data.append('objs', param);
      this.$http.post('/api/select/couponPubList?access_token='+token, data, null)
      .then((result) => {
        this.pub_items = result.data;
        this.pub_totalRows = this.pub_items.length;
      })
    },
    // 메소드명 : couponSave()
    // ### 신규 쿠폰 저장 ###
    // couponDetail를 신규 쿠폰으로 저장
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    couponSave(){
      this.couponDetail.coupon_code = 'CP' + moment().format('YYYYMMDD'); // 쿠폰 코드값(base) 만들기
      this.couponDetail.coupon_status = '1';
      if(this.couponDetail.coupon_type == 'CT_1'){
        this.couponDetail.opt_type= '1';
      }else{
        this.couponDetail.opt_type= '2';
      }

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.couponDetail));
      var data = new FormData();
      data.append('objs', param);
      this.$http.post('/api/insert/newcoupon?access_token='+token, data, null)
      .then((result) => {
        swal.fire({
          type: 'success',
          title: '신규 쿠폰을 등록하였습니다.',
          showConfirmButton: false,
          timer: 1500
        })
        this.formModal = false;
      })
    },
    // 메소드명 : couponRowSelected(item, index, event)
    // ### 쿠폰 선택 이벤트 함수 ###
    // 쿠폰 리스트 테이블에서 쿠폰을(row) 클릭했을시 발생하는 이벤트 함수
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    couponRowSelected(item, index, event) {
      this.selectedCoupon = item;
      this.selectCouponPubList();
      this.showPubManagement = true;
    },
    // 메소드명 : expirePubCoupon(pubCoupon)
    // ### 발행 쿠폰 만료 ###
    // 선택된 쿠폰을 만료상태로 변경
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    expirePubCoupon(pubCoupon){
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(pubCoupon));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/update/couponPubExpire?access_token=' + token, data, null)
        .then((result) => {
          this.selectCouponPubList();
      })
    },
    // 메소드명 : findUser()
    // ### 사용자 조회 ###
    // 발행쿠폰을 지급할 사용자 조회
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    findUser() {
      this.listLoading = true;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.user_queryParams));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/reportUserList?access_token=' + token, data, null)
        .then((result) => {
          // console.log(result.data);
          this.listLoading = false;
          this.user_items = result.data;
          this.user_totalRows = this.user_items.length;
        })
    },
    // 메소드명 : user_rowSelected(item, index, event)
    // ### 사용자 선택 ###
    // 발행쿠폰을 지급할 사용자 선택시 발생하는 이벤트 함수
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    user_rowSelected(item, index, event){
      // 쿠폰 발급
      this.selectedPubCoupon.user_id = item.user_id;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.selectedPubCoupon));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/update/couponPubUser?access_token=' + token, data, null)
        .then((result) => {

          this.searchModal = false;
          this.selectCouponPubList();
      })
    },
    // 메소드명 : selectPubCoupon(item)
    // ### 발행쿠폰 관리 버튼 클릭 ###
    // 발행쿠폰 관리 버튼(지급/만료)을 클릭했을시 실행하는 함수
    //
    // 최초작성 : 2019.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    selectPubCoupon(item){
      this.selectedPubCoupon = item;
      this.searchModal = true;
    }
  }
}
</script>

<style src="daterangepicker/daterangepicker.css"/>

<style lang="css"scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/coupon/CouponManagement.vue